import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Cognitive Reappraisal — FTUE demo (3 essais).
 *
 * E1 : scénario file d'attente + exemple stratégie temporel
 * E2 : scénario collègue tendu, le joueur applique seul
 * E3 : signal "prêt"
 */
import { useState } from 'react';
const DEMO_STEPS = [
    {
        idx: 1,
        title: 'Essai 1 — File d\'attente',
        hint: 'Lis, puis évalue avant et après une reformulation.',
        scenarioText: "Tu es bloqué dans une longue file d'attente à la caisse.",
        example: 'Stratégie temporel : « Dans 5 minutes, ce sera derrière moi. »',
    },
    {
        idx: 2,
        title: 'Essai 2 — Collègue tendu',
        hint: 'Choisis ta propre stratégie pour reformuler.',
        scenarioText: 'Un collègue te répond sèchement en réunion. Tu te demandes pourquoi.',
    },
    {
        idx: 3,
        title: 'Essai 3 — prêt',
        hint: 'Le round normal compte 4-8 scénarios selon ton niveau.',
        scenarioText: 'Ton train de banlieue affiche 25 minutes de retard.',
    },
];
export function Demo({ onComplete, onSkip }) {
    const [stepIdx, setStepIdx] = useState(0);
    const [phase, setPhase] = useState('before');
    const [before, setBefore] = useState(5);
    const [after, setAfter] = useState(5);
    const step = DEMO_STEPS[stepIdx];
    const isLast = stepIdx === DEMO_STEPS.length - 1;
    const handleNext = () => {
        if (phase === 'before') {
            setPhase('after');
            return;
        }
        if (isLast) {
            onComplete();
            return;
        }
        setStepIdx((i) => i + 1);
        setPhase('before');
        setBefore(5);
        setAfter(5);
    };
    return (_jsxs("div", { className: "flex flex-1 flex-col items-center gap-s4 py-s4 text-center", children: [_jsx("p", { className: "font-mono text-[9.5px] uppercase tracking-[0.30em] text-cyan-text-faint", children: "D\u00E9mo guid\u00E9e" }), _jsx("h2", { className: "font-display text-[22px] font-medium leading-7 tracking-cy-display text-cyan-text", children: step.title }), _jsx("p", { className: "max-w-[320px] text-[13.5px] text-cyan-text-secondary", children: step.hint }), _jsxs("div", { className: "flex w-full max-w-[320px] flex-col gap-s3 border border-cyan-border-faint bg-cyan-surface p-s4 text-start", children: [_jsx("p", { className: "font-mono text-[10px] uppercase tracking-[0.20em] text-cyan-text-faint", children: "Sc\u00E9nario" }), _jsx("p", { className: "text-[14px] leading-5 text-cyan-text", children: step.scenarioText })] }), step.example && phase === 'before' && (_jsx("p", { className: "text-[12px] text-cyan-text-secondary", children: step.example })), phase === 'before' && (_jsxs("div", { className: "flex w-full max-w-[320px] flex-col gap-s2", children: [_jsx("p", { className: "text-[13px] text-cyan-text-secondary", children: "Intensit\u00E9 avant ?" }), _jsx("input", { type: "range", min: 1, max: 9, value: before, onChange: (e) => setBefore(parseInt(e.target.value, 10)), className: "w-full accent-cyan-core" }), _jsxs("span", { className: "font-display text-[24px] font-medium tracking-cy-display text-cyan-text", children: [before, " / 9"] })] })), phase === 'after' && (_jsxs("div", { className: "flex w-full max-w-[320px] flex-col gap-s2", children: [_jsx("p", { className: "text-[13px] text-cyan-text-secondary", children: "Intensit\u00E9 apr\u00E8s reformulation ?" }), _jsx("input", { type: "range", min: 1, max: 9, value: after, onChange: (e) => setAfter(parseInt(e.target.value, 10)), className: "w-full accent-cyan-core" }), _jsxs("span", { className: "font-display text-[24px] font-medium tracking-cy-display text-cyan-text", children: [after, " / 9"] })] })), _jsxs("div", { className: "mt-auto flex flex-col items-stretch gap-s3 self-stretch", children: [_jsx("button", { type: "button", onClick: handleNext, className: "inline-flex h-12 w-full items-center justify-center bg-cyan-core font-display text-[14px] font-medium tracking-[-0.01em] text-cyan-surface transition active:scale-[0.985] hover:bg-cyan-network", children: phase === 'before'
                            ? 'Reformuler'
                            : isLast
                                ? 'Démarrer la session'
                                : 'Essai suivant' }), _jsx("button", { type: "button", onClick: onSkip, className: "text-[12px] text-cyan-text-secondary underline-offset-4 hover:underline", children: "Passer la d\u00E9mo" })] })] }));
}
//# sourceMappingURL=demo.js.map